import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36d1a415"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup--content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_List = _resolveComponent("List")!
  const _component_uf_popup = _resolveComponent("uf-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, _mergeProps({
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          onClick: _ctx.handleFiledClick,
          readonly: "",
          disabled: _ctx.disabled,
          "is-link": !_ctx.disabled
        }, _ctx.$attrs, {
          placeholder: _ctx.isEventDetail ? '-' : '请选择'
        }), null, 16, ["modelValue", "onClick", "disabled", "is-link", "placeholder"])
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    _createVNode(_component_uf_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom",
      onCancel: _ctx.handleCancel,
      onClear: _ctx.handleClearVal,
      onOk: _ctx.handleOk,
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_List, {
            modelValue: _ctx.checkedVal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedVal) = $event)),
            options: _ctx.innerOptions
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _: 1
    }, 8, ["show", "onCancel", "onClear", "onOk"])
  ], 64))
}